export default __webpack_public_path__ + "static/media/presale-img.d1aa6991.png";